import React from "react"
import styles from "./VerticalLine.module.css";

const VerticalLine = (props) => {
    return(
        <div className={styles.VerticalLine} {...props}></div>
    );
}

export default VerticalLine;